import { BagCarryOnIcon } from './BagCarryOnIcon';

/**
 * author: Google
 * id 0B935A7D-05EB-4687-8E4B-BC075AA2FA85
 * name bag-carry-on
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bag-carry-on.svg
 * tags
 * - Transportation + Flying 
 */
export const CarryOnLuggageIcon = BagCarryOnIcon;
export default CarryOnLuggageIcon